/**
 * Product Detail Functions
 * Handles quantity controls and form interactions for product detail page
 */

class ProductDetailFunctions {
	constructor() {
		this.init();
	}

	init() {
		if (!$(".is-detail").length && !$(".product-detail-page").length) {
			return;
		}

		this.setupRevealAnimations();
		this.setupGallery();
		this.setupQuantityControls();
		this.setupFormValidation();
		this.setupModalInteractions();
	}

	setupRevealAnimations() {
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add("revealed");
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
		);

		document
			.querySelectorAll(
				".product-hero, .product-content-section, .related-products, .related-item"
			)
			.forEach(function (el) {
				el.classList.add("reveal");
				observer.observe(el);
			});
	}

	setupGallery() {
		$(".gallery-thumbs .item-single").on("click", function (e) {
			e.preventDefault();
			var imgSrc = $(this).find("img").attr("src");
			var fullSrc = $(this).attr("data-src") || imgSrc;
			$("#main-product-image").attr("src", fullSrc);
			$(".gallery-thumbs .item-single").removeClass("active");
			$(this).addClass("active");
		});

		$(".gallery-thumbs .item-single:first").addClass("active");
	}

	setupQuantityControls() {
		const self = this;

		$(".quantity-minus").on("click", function () {
			const input = $("#quantity");
			const val = parseInt(input.val());
			if (val > 1) {
				input.val(val - 1);
			}
		});

		$(".quantity-plus").on("click", function () {
			const input = $("#quantity");
			const val = parseInt(input.val());
			if (val < 99) {
				input.val(val + 1);
			}
		});

		$("#quantity").on("input", function () {
			const value = parseInt(this.value);
			if (value < 1) this.value = 1;
			else if (value > 99) this.value = 99;
		});
	}

	setupFormValidation() {
		$("#form_addcart").on("submit", function (e) {
			e.preventDefault();
			const quantity = $("#quantity").val();
			const productId = $("#product").val();
			if (!quantity || quantity < 1 || !productId) {
				return;
			}
		});
	}

	setupModalInteractions() {
		$(".btn-addConfirm").on("click", function () {
			const quantity = $("#quantity").val();
			$("#popup-quantity").text(quantity);
		});

		$("#modalOrderConfirm").on("show.bs.modal", function () {
			const quantity = $("#quantity").val();
			$("#popup-quantity").text(quantity);
		});
	}

	static init() {
		if (document.querySelector(".is-detail")) {
			new ProductDetailFunctions();
		}
	}
}

$(document).ready(function () {
	ProductDetailFunctions.init();
});
